/*
 * The bundler fills in these constants at build time
 * with the values taken from an `env` file.
 */

export const googleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID || "0";
export const cloudflareAnalyticsId = process.env.CLOUDFLARE_ANALYTICS_ID || "0";
export const cookiebotClientId = process.env.COOKIEBOT_CLIENT_ID || "0";
export const paddleToken = process.env.PADDLE_TOKEN || "0";
export const paddlePriceId = process.env.PADDLE_PRICE_ID || "0";

/**
 * Whether to offer the premium account at all.
 *
 * Off by default, so a site with no payment provider set up never shows a price
 * or a buy button that could only fail. Turn it on — `PREMIUM_ENABLED=1` — once
 * Paddle is registered and `PADDLE_TOKEN` and `PADDLE_PRICE_ID` are filled in.
 *
 * This lives beside the other Paddle client settings rather than in the root
 * `.env` because it is read by code that runs in the browser: the bundler
 * substitutes the value at build time, so a change here needs a rebuild, not
 * just a restart. That is true of `PADDLE_TOKEN` itself, so switching premium
 * on was always going to mean rebuilding anyway.
 */
export const premiumEnabled = (process.env.PREMIUM_ENABLED || "0") !== "0";

/**
 * Whether to run advertising at all.
 *
 * Off by default, for the same reason premium is: the ad script is fetched from
 * a per-site path (`a.pub.network/<site>/pubfig.min.js`), so a site that is not
 * registered with Freestar gets a 404 on every page load, while the consent
 * banner offers an "Advertising" category that can grant nothing. With this off
 * the script is never requested, the ad slots render nothing, and the category
 * disappears from the banner and the cookie declaration.
 *
 * Turn it on — `ADS_ENABLED=1` — once the site exists in the Freestar dashboard.
 * Baked into the bundle at build time, so changing it needs a rebuild.
 */
export const adsEnabled = (process.env.ADS_ENABLED || "0") !== "0";
